














































import { Component, Prop, Vue } from 'vue-property-decorator'
import Sticky from '@/components/Sticky/index.vue'
import { Form } from 'element-ui'

import { getVendor, updateVendor } from '@/api/vendors'
import { getVendorCompanyById, updateVendorCompany } from '@/api/vendorCompany'
import { AppModule } from '@/store/modules/app'
import { TagsViewModule, ITagView } from '@/store/modules/tags-view'
import { VendorsModule } from '@/store/modules/vendors'
import { VendorCompaniesModule } from '@/store/modules/vendorCompanies'
import VendorCompany from './VendorCompany.vue'
import VendorInformation from './VendorInformation.vue'
import VendorLicenses from './VendorLicenses.vue'
import VendorStatus from './VendorStatus.vue'
import { updateSameAsFields } from '@/utils/vendors'
import { IVendor, IVendorCompany } from '@/api/types-vendor'

@Component({
  name: 'VendorEdit',
  components: {
    VendorInformation,
    VendorCompany,
    VendorLicenses,
    VendorStatus,
    Sticky
  }
})
export default class extends Vue {
  @Prop({ default: false }) private isEdit!: boolean
  @Prop({ default: false }) private isCreate!: boolean

  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  private vendorForm = VendorsModule.createNewItem()
  private vendorCompanyForm: IVendorCompany = VendorCompaniesModule.createNewItem()
  private loading = true
  private title = 'Vendor Edit'
  private rules = {
    firstName: [{ validator: this.validateRequire }],
    lastName: [{ validator: this.validateRequire }],
    phone: [{ validator: this.validateRequire }],
    email: [{ validator: this.validateRequire }]
  }

  private tempTagView?: ITagView

  get lang() {
    return AppModule.language
  }

  created() {
    if (this.isEdit) {
      let vendorId = 0
      this.vendorCompanyForm = VendorCompaniesModule.createNewItem()
      if (!this.isCreate) {
        const id = this.$route.params && this.$route.params.id
        vendorId = parseInt(id)
      }
      this.fetchData(vendorId)
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route)
    console.log(`created ${this.tempTagView?.path}, ${this.tempTagView?.name}`)
  }

  private async fetchData(id: number) {
    try {
      // load the Vendor main record.
      console.log(`VendorEdit.vue fetchData(${id}) isCreate=${this.isCreate}`)
      this.loading = true

      const { data } = await getVendor(id)
      this.vendorForm = data
      if (id === 0 && this.isCreate) {
        this.title = 'Create Vendor'
      } else {
        VendorsModule.setSelectedVendor(this.vendorForm)
        this.title = `${this.vendorForm.vendorId} ${this.vendorForm.lastName}, ${this.vendorForm.firstName}`
      }
      // Set tagsview title
      this.setTagsViewTitle(this.title)
      // Set page title
      this.setPageTitle(this.title)

      this.fetchVendorCompany(this.vendorForm.vendorCompanyId)
      this.loading = false
    } catch (err) {
      console.error(err)
    }
  }

  async fetchVendorCompany(id: number) {
    try {
      // load the VendorCompany record.
      const { data } = await getVendorCompanyById(id)
      this.vendorCompanyForm = data
    } catch (err) {
      console.error(err)
    }
  }

  private setTagsViewTitle(title: string) {
    const tagView = this.tempTagView
    console.log(`setTagsView ${title} ${tagView?.path}, ${tagView?.name}`)
    if (tagView) {
      tagView.title = title
      TagsViewModule.updateVisitedView(tagView)
    }
  }

  private setPageTitle(title: string) {
    document.title = title
  }

  private closeTagView() {
    const tagView = this.tempTagView
    if (tagView) {
      TagsViewModule.delView(tagView)
      this.toLastView(TagsViewModule.visitedViews, tagView)
    }
  }

  private toLastView(visitedViews: ITagView[], view: ITagView) {
    const latestView = visitedViews.slice(-1)[0]
    if (latestView !== undefined && latestView.fullPath !== undefined) {
      this.$router.push(latestView.fullPath).catch(err => {
        console.warn(err)
      })
    } else {
      // Default redirect to the home page if there is no tags-view, adjust it if you want
      if (view.name === 'Dashboard') {
        // to reload home page
        this.$router.replace({ path: '/redirect' + view.fullPath }).catch(err => {
          console.warn(err)
        })
      } else {
        this.$router.push('/').catch(err => {
          console.warn(err)
        })
      }
    }
  }

  private submitForm() {
    (this.$refs.vendorForm as Form).validate(async valid => {
      console.debug('Vendor Submit')
      if (valid) {
        this.loading = true
        debugger

        if (this.vendorForm.vendorCompanyId !== 0) {
          const vc = updateSameAsFields(this.vendorForm, this.vendorCompanyForm)
          const { data } = await updateVendorCompany(this.vendorForm.vendorCompanyId, vc)
          this.vendorCompanyForm = data as IVendorCompany
        }

        const { data } = await updateVendor(this.vendorForm.vendorId, this.vendorForm)
        this.vendorForm = data as IVendor

        this.loading = false
        this.$notify({
          title: 'Success',
          message: `Vendor ${this.vendorForm.vendorId} saved successfully.`,
          type: 'success',
          duration: 2000
        })
        this.closeTagView()
        return true
      } else {
        console.log('Validation errors!')
      }
      this.loading = false
      return false
    })
  }

  private cancelForm() {
    this.closeTagView()
    return true
  }
}
